<template>
    <div style="width: 100%; margin: 0 auto; background: #f5f5f5; position: relative;" class="ccc">
        <div class="container"
            :style="{ '--background': (backgroundImage.indexOf('http') > -1 || backgroundImage.indexOf('https') > -1 ? 'url(' + backgroundImage + ')' : backgroundImage) }">
            <div class="title">{{ title }}</div>
            <div class="jackpot" style="margin-top: 24px;padding-right:60px;padding-right:60px">
                <div style="display: flex;width: 100%;">
                    <div style="flex: 1;display: flex;justify-content: center;align-items: center;flex-direction: column;">
                        <div style='font-size: 26px; font-weight: 400; color: #FFF;'>
                            <span>幸运大抽奖</span>
                        </div>
                        <div style="font-size:26px; font-weight: 400;margin-top: 25px;color: #FFF;">
                            <span>好礼送不停</span>
                        </div>
                        <div
                            style="width: 180px;border-radius: 100px;background: #AE223D;height: 38px;text-align: center;line-height: 38px; color: #f9df83; font-size: 14px;margin-top: 34px;">
                            <span>您当前拥有</span>
                            <span style="font-size: 22px;color: #FFF;">{{ userDrawPrizeNumber_ }}</span>
                            <span>次抽奖机会</span>
                        </div>
                    </div>
                    <div class="lottery__"
                        style="display: flex;justify-content: center;align-items: center;position: relative;">
                        <LuckyGrid ref="myLucky" class="myLucky_" width="270.5" height="250" :blocks="blocks"
                            :prizes="prizes" :buttons="buttons" @start="startCallback" @end="endCallback" />
                        <div style="position:absolute;bottom:10%;left:33%;height:43px;width:200px;cursor:pointer;"
                            @click="lotteryShowBtn">

                        </div>
                    </div>
                </div>
            </div>
            <div class="" v-if="taskLIstdata.length"
                style="margin-top:15px;border: 1px solid #333333;backdrop-filter: blur(25px);padding: 16px;width: 100%;border-radius: 8px;background: #FFF;">
                <div style=" font-weight: 700; color: #333333; font-size: 15px;">
                    <span>抽奖任务</span>
                </div>
                <div style="display:flex;align-items:center;column-gap:20px;row-gap:20px;flex-wrap:wrap;margin-top:24px;">
                    <!-- width:31.2%; -->
                    <div v-for="(item, index) in taskLIstdata" :keys="item.id"
                        :style="[{ flex: 1, display: 'flex', justifyContent: 'space-between', flexDirection: taskLIstdata.length == 1 ? 'row' : 'column', background: '#f1f1f1', borderRadius: '12px', padding: '16px', boxSizing: 'border-box', height: taskLIstdata.length == 1 ? 'auto' : '178px', }]">
                        <div>
                            <div style=" color: #333333; font-size: 14px; font-weight: 700;"><span>{{
                                item.taskTitle }}({{ item.userTaskNumberComplete }}/{{ item.taskType == 1
        ? (item.userTaskNumber + "次") : (item.taskNumber + "条") }})</span></div>
                            <div style="margin-top: 8px; color: #333333; font-size: 14px; font-weight: 400;">
                                <span>{{ item.taskContent }}</span>
                            </div>
                        </div>
                        <div v-if="item.taskStatus == 1" @click="goToTask(item)"
                            style="background: #C01A26; border-radius:100px; width: 104px; height: 37px; text-align: center; line-height: 37px; color: #FFF;cursor: pointer;">
                            <span>{{ item.taskType == 1 ? '去完成' : "查看详情" }}</span>
                        </div>
                        <div v-if="item.taskStatus == 2 || item.taskStatus == 3"
                            style="background: #E3E6EC;border-radius: 100px;width: 104px;height: 37px;text-align: center;line-height: 37px;color: #333333;cursor:not-allowed;">
                            <span>{{ item.taskStatus == 2 ? '已完成' : "已结束" }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div ref="previewRef" class="preview" style="margin-top:15px;" v-html="content">
            </div>
            <div v-if="!isOver()" class="tip">
                <span>倒计时</span>
                <span style="font-size: 19px;">{{ getDay() }}</span>
                <span>DAYS</span>
            </div>
            <div class="share" @click.stop="handleShare">
                <el-icon style="width: 20px;height: 20px;"><svg style="width: 20px;height: 20px;" viewBox="0 0 1024 1024"
                        version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M928 480c-17.664 0-32 14.336-32 32l0 320c0 17.664-14.336 32-32 32L160 864c-17.664 0-32-14.336-32-32L128 288c0-17.664 14.336-32 32-32l224 0 0 0c0 0 0 0 0 0 17.664 0 32-14.336 32-32s-14.336-32-32-32c-1.024 0-1.888 0.48-2.88 0.576L160.384 192.576c-52.96 0-95.904 43.008-95.904 96.064l0 543.872c0 53.056 42.944 96.064 95.904 96.064l704.224 0c52.96 0 95.904-43.008 95.904-96.064L960.512 512 960 512C960 494.336 945.664 480 928 480zM402.688 620.768c-1.92 4.128-3.168 8.608-3.168 13.44 0 17.664 14.336 32 32 32 15.456 0 27.744-11.168 30.752-25.76l0.64 0c37.12-189.696 193.984-336.256 388.672-358.272l-67.776 67.776c-12.512 12.512-12.512 32.768 0 45.248 12.512 12.512 32.768 12.512 45.248 0l122.528-122.528c12.512-12.512 12.512-32.768 0-45.248l-122.528-122.528c-12.512-12.512-32.768-12.512-45.248 0-12.512 12.512-12.512 32.768 0 45.248l67.52 67.52C628.256 239.872 448.224 405.408 402.688 620.768z">
                        </path>
                    </svg></el-icon>
                <span>分 享</span>
            </div>
            <el-dialog v-model="isShowShare" :close-on-click-modal="false" :show-close="true" title="分享" width="500">
                <div class="" style="display: flex;align-items: center;justify-content: center;flex-direction: column;">
                    <div class="">
                        <canvas ref="qrcodeCanvas"></canvas>
                    </div>
                    <div class="" style=" color: #333333; font-size: 14px;">
                        扫描二维码，参与内容
                    </div>

                </div>
                <div style="margin-top: 16px;">
                    <div style=" color: #333333; font-size: 14px;">
                        <span>分享活动链接</span>
                    </div>
                    <div
                        style="border: 1px solid  #E5E6EB;border-radius: 8px;height: 45px;width: 100%;line-height: 45px;text-align: left;margin-top: 8px;color: #000000;padding-left: 12px;">
                        <span>{{ `https://biaoshisx.com/drawList?id=${id}` }}</span>
                    </div>
                </div>
                <div @click="copyBtn"
                    style="background:#2978FF;border-radius: 12px;height: 45px;width: 100%;text-align: center;line-height: 45px;color: #FFF;margin-top: 8px;cursor: pointer;">
                    <span>复制链接</span>
                </div>
            </el-dialog>
            <el-dialog v-model="addressShow__" :close-on-click-modal="false" :show-close="true" title="快递信息" width="500">
                <div>
                    <div style=" color: #333333; font-size: 14px;text-align: center;">
                        <span>您的快递单号为</span>
                    </div>
                    <div
                        style="border-radius: 8px;height: 45px;width: 100%;line-height: 45px;text-align: left;margin-top: 8px;color: #000000;padding-left: 12px;">
                        <span>{{ addressShow__item.trackingNumber }}</span>
                    </div>
                </div>
                <div @click="copyBtn('a')"
                    style="background:#2978FF;border-radius: 12px;height: 45px;width: 100%;text-align: center;line-height: 45px;color: #FFF;margin-top: 8px;cursor: pointer;">
                    <span>复制链接</span>
                </div>
            </el-dialog>
            <el-dialog v-model="lotteryShow" top="50px" v-loading="lotteryLoading" :close-on-click-modal="false"
                :show-close="true" title="我的奖励" width="600">
                <div class="">
                    <div v-if="!lotteryList.length">
                        <el-empty description="暂无抽奖记录" />
                    </div>
                    <div v-if="lotteryList.length">
                        <div v-for="item in lotteryList" :key="item.id"
                            style="display: flex;justify-content: space-between;align-items: center;" class="sp">
                            <div style="display: flex;column-gap: 5px;">
                                <div style="width: 80px;height: 80px;border-radius: 8px;">
                                    <img :src="item.prizeImage" style="width: 80px;height: 80px;border-radius: 8px;" alt=""
                                        srcset="">
                                </div>
                                <div style=" color: #000000; font-size: 16px;"><span>{{ item.prizeName }}</span></div>
                            </div>
                            <div v-if="item.status == 1" @click="conversionBtn('c', item)"
                                style="background: #C01A26;border-radius: 100px;width:104px;height:37px; color: #ffffff; font-size: 14px;text-align: center;line-height: 37px;cursor: pointer;">
                                <span>{{ item.prizeType == 1 ? '立即兑换' : '填写地址' }}</span>
                            </div>
                            <div v-if="item.status == 2 && item.prizeType == 1"
                                style="background: #C01A26;border-radius: 100px;width:104px;height:37px; color: #ffffff; font-size: 14px;text-align: center;line-height: 37px;cursor: pointer;">
                                <span>处理中</span>
                            </div>
                            <div v-if="item.status == 3 && item.prizeType == 1"
                                style="background: #E3E6EC;border-radius: 100px;width: 104px;height: 37px;text-align: center;line-height: 37px;color: #333333;cursor:not-allowed;">
                                <span>已兑换</span>
                            </div>
                            <div @click="trackingNumberbtn(item)"
                                v-if="(item.status == 2 || item.status == 3) && item.prizeType == 2"
                                style="background: #C01A26;border-radius: 100px;width:104px;height:37px; color: #ffffff; font-size: 14px;text-align: center;line-height: 37px;cursor: pointer;">
                                <span>查看快递单号</span>
                            </div>
                        </div>
                    </div>

                    <!-- <div style="display: flex;justify-content: space-between;align-items: center;" class="sp">
                    <div style="display: flex;column-gap: 5px;">
                        <div style="width: 80px;height: 80px;background: red;border-radius: 8px;"></div>
                        <div style=" color: #000000; font-size: 16px;"><span>填写地址</span></div>
                    </div>
                    <div @click="addressShowBtn"
                        style="background: #C01A26;border-radius: 100px;width:104px;height:37px; color: #ffffff; font-size: 14px;text-align: center;line-height: 37px;cursor: pointer;">
                        <span>填写地址</span>
                    </div>
                </div> -->
                    <div v-if="lotteryList.length"
                        style="display: flex;justify-content: flex-end;align-items: center;width: 100%;">
                        <el-pagination style="color: red;" :total="lotteryPage.total" :current-page="lotteryPage.pageNum"
                            @current-change="paginationChange" :page-size="lotteryPage.pageSize" />
                    </div>
                </div>
                <div
                    style=" color: #ff8741; font-size: 14px;border-radius: 8px;background: #ff874126;padding-left: 10px;height: 37px;margin-top: 20px;line-height: 37px;">
                    <span>联系客服咨询奖品相关信息</span>
                </div>
                <div
                    style=" font-size: 16px; color: #c01a26;text-align: center;margin-top: 15px;cursor: pointer;position: relative;">
                    <span @click="kefuShowBtn = !kefuShowBtn">联系客服</span>
                    <div class="" v-if="kefuShowBtn"
                        style="position: absolute;right:-294px;top:-256px;box-shadow: 0 4px 12px 0 #0000001a;border: 1px solid #E5E6EB;background: #FFF;border-radius: 12px;width: 260px;height: 293px;padding: 40px;">
                        <img src="../../assets/kf.jpg"
                            style="border:1px solid #E5E6EB; width: 180px;height: 180px;border: 10px;" alt="" srcset="">
                        <div style=" color: #333333; font-size: 14px;">
                            <span>扫描二维码，添加客服微信</span>
                        </div>
                    </div>
                </div>
                <!-- <div @click="clotteryShowBtn"
                    style="background:#2978FF;border-radius: 12px;height: 45px;width: 100%;text-align: center;line-height: 45px;color: #FFF;margin-top: 8px;cursor: pointer;">
                    <span>复制链接</span>
                </div> -->
            </el-dialog>
            <el-dialog v-model="conversionShow" :close-on-click-modal="false" :show-close="true" title="兑换奖品" width="500">
                <el-form :model="conversionData" :close-on-click-modal="false" :destroy-on-close="true"
                    :rules="conversionRules" ref="conversion_" style="width: 100%;" label-position="top" :inline="true"
                    class="custom-label-height">
                    <el-form-item label="收货人" prop="name" style="width: 100%;margin-right: 0;"
                        v-if="conversionType.prizeType == 2">
                        <el-input size="large" style="width: 100%;" v-model="conversionData.name" placeholder="请输入收货人"
                            clearable />
                    </el-form-item>
                    <el-form-item label="兑换手机号" prop="prizePhone" style="width: 100%;margin-right: 0;">
                        <el-input size="large" style="width: 100%;" v-model="conversionData.prizePhone"
                            placeholder="请输入兑换手机号" clearable />
                    </el-form-item>

                    <el-form-item label="所在地区" prop="address" style="width: 100%;margin-right: 0;"
                        v-if="conversionType.prizeType == 2">
                        <!-- <el-input size="large" style="width: 100%;" v-model="conversionData.address" placeholder="请输入所在地区"
                        clearable /> -->
                        <el-cascader style="width: 100%;" v-model="conversionData.address" :props="{
                            value: 'name',
                            label: 'name'
                        }" :options="sx" @change="handleChange" />
                    </el-form-item>
                    <el-form-item label="详细地址" prop="addressDetail" style="width: 100%;margin-right: 0;"
                        v-if="conversionType.prizeType == 2">
                        <el-input size="large" type="textarea" style="width: 100%;" v-model="conversionData.addressDetail"
                            placeholder="请输入详细地址" clearable />
                    </el-form-item>
                    <div v-if="conversionType.prizeType == 2"
                        style="width: 100%;color: #ff8741; font-size: 14px;border-radius: 8px;background: #ff874126;padding-left: 5px;height: 37px;margin-top: 10px;line-height: 37px;">
                        <span>核对信息后，将在1-3个工作日进行发货处理</span>
                    </div>
                    <div class="" @click="conversionClick(conversion_)"
                        style="height: 40px; border-radius: 12px;background: #2978FF;color: #FFF;text-align: center;line-height: 40px; font-size: 14px;margin-bottom: 16px;cursor: pointer;width:100%;margin-top:20px">
                        <span>确认兑换</span>
                    </div>
                </el-form>
            </el-dialog>

            <div style="position:fixed;left:50%;top:50%;transform: translate(-50%,-50%);z-index: 9999;background:rgba(0,0,0,0.5);width:100%;height:100%;"
                v-if="ts">
                <div class="l"
                    style="height: 454px;width: 380px;background: linear-gradient(180deg, #FFF5D1 0%, #FFFCF2 100%);border-radius: 12px;margin:160px auto;padding:45px 20px 20px;display:flex;flex-direction: column;align-items: center;">
                    <div style="" class="x"></div>
                    <div style=" color: #333333; font-size: 16px; font-weight: 400;margin-top:20px;">
                        <span>恭喜您获得{{ pitchDetail.name }}</span>
                    </div>
                    <div style="height: 150px;width: 150px;margin-top:16px;">
                        <img :src="pitchDetail.image" style="width:100%;height:100%;border-radius: 8px;" />
                    </div>
                    <div style=" color: #333333; font-size: 16px; font-weight: 400;margin-top:10px;">
                        <span>{{ pitchDetail.name }} </span>
                    </div>
                    <div
                        style="width:100%;height:58px;background: #ff874126;border-radius: 8px; font-size: 14px; color: #ff8741;text-align:left;margin-top:20px;cursor: pointer;padding:10px 8px;box-sizing: border-box;">
                        <span>中奖产品可在“我的奖励”中点击查看，如有疑问可联系客服咨询奖品相关信息</span>
                    </div>
                    <div style="display:flex;justify-content: center;width:100%;margin-top:20px;column-gap:12px;">
                        <div @click="ts = false"
                            style="width: 112px;border: 1px solid #333;border-radius: 100px;height:44px;text-align:center;line-height:44px;cursor: pointer;margin-top:20px; color: #333333; font-size: 16px;">
                            <span>关闭</span>
                        </div>
                        <div @click="conversionBtn('clear')"
                            style="width: 112px;background: linear-gradient(90deg, #3C3026 0%, #2E261F 100%);border-radius: 100px;height:44px;text-align:center;line-height:44px;cursor: pointer;margin-top:20px;  color: #ffe8d4; font-size: 16px;">
                            <span>立即兑换</span>
                        </div>
                    </div>
                </div>
            </div>
            <div style="position:fixed;left:50%;top:50%;transform: translate(-50%,-50%);z-index: 9999;background:rgba(0,0,0,0.5);width:100%;height:100%;"
                v-if="thanksShow">
                <div class="l"
                    style="height: 260px;width: 380px;background: linear-gradient(180deg, #FFF5D1 0%, #FFFCF2 100%);border-radius: 12px;margin:160px auto;padding:45px 20px 20px;display:flex;flex-direction: column;align-items: center;">
                    <div style="" class="x_"></div>
                    <div style=" color: #333333; font-size: 16px; font-weight: 400;margin-top:20px;">
                        <span>很遗憾，您未抽中奖品！</span>
                    </div>
                    <div
                        style="width:100%;height:58px;background: #ff874126;border-radius: 8px; font-size: 14px; color: #ff8741;text-align:left;margin-top:20px;cursor: pointer;padding:10px 8px;box-sizing: border-box;">
                        <span>中奖产品可在“我的奖励”中点击查看，如有疑问可联系客服咨询奖品相关信息</span>
                    </div>
                    <div style="display:flex;justify-content: center;width:100%;column-gap:12px;">
                        <div @click="thanksShow = false"
                            style="width: 112px;border: 1px solid #333;border-radius: 100px;height:44px;text-align:center;line-height:44px;cursor: pointer;margin-top:20px; color: #333333; font-size: 16px;">
                            <span>关闭</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script lang="ts" setup>
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import QRCode from 'qrcode'
let sx = require("./i.json");
import useClipboard from 'vue-clipboard3'
const route = useRoute();
const thanksShow = ref(false);
import { ref, onBeforeMount, onMounted, nextTick, watch, reactive } from "vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import axios from "axios";
import getsignatureInfo from "../../wx/index.js";
import { error } from "console";
const router = useRouter();
// const joinText = ref('立即报名')
const content = ref('')
const title = ref('')
const ts = ref(false);
const kefuShowBtn = ref(false);
const qrcodeCanvas = ref<any>(null)
const backgroundImage = ref('')
const conversionData = ref({
    prizePhone: "",
    name: "",
    address: "",
    addressDetail: ""
});
const conversion_ = ref();
const addressShow__ = ref(false);
const previeHeight = ref(0)
const id = ref<number | undefined | string>(0)
const previewRef = ref<any>()
const stopTime = ref()
const startTime = ref()
const isShowShare = ref(false)
const lotteryShow = ref(false);
const isJoin = ref(0)
const conversionShow = ref(false);
const conversionType: any = ref({});
const { toClipboard } = useClipboard()
const activityType: any = ref(0);
const lotteryLoading = ref(false);
import b from "@/assets/lj.png"
import { fa } from "element-plus/es/locale";
const checkPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('手机号不能为空'));
    } else {
        const reg = /^1[0-9]{10}$/
        if (reg.test(value)) {
            callback();
        } else {
            return callback(new Error('请输入正确的手机号'));
        }
    }
}
const conversionRules = reactive({
    prizePhone: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { validator: checkPhone, trigger: 'blur' }],
    name: [{ required: true, message: '请输入收货人', trigger: 'blur' }],
    address: [{ required: true, message: '请选择所在地区', trigger: 'blur' }],
    addressDetail: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
});
const handleChange = (e) => {
    console.log(e, conversionData.value)
}
const myLucky = ref<any>(null)
const blocks = [{ padding: '13px', background: 'transparent' }];
const prizes: any = ref([
    { x: 0, y: 0, fonts: [{ text: '', top: '73%', textAlign: 'center', fontSize: '8px', fontColor: "#F33030" }], background: '#FFFBE6', imgs: [] },
    { x: 1, y: 0, fonts: [{ text: '', top: '73%', textAlign: 'center', fontSize: '8px', fontColor: "#F33030" }], background: '#FFFBE6', imgs: [] },
    { x: 2, y: 0, fonts: [{ text: '', top: '73%', textAlign: 'center', fontSize: '8px', fontColor: "#F33030" }], background: '#FFFBE6', imgs: [] },
    { x: 2, y: 1, fonts: [{ text: '', top: '73%', textAlign: 'center', fontSize: '8px', fontColor: "#F33030" }], background: '#FFFBE6', imgs: [] },
    { x: 2, y: 2, fonts: [{ text: '', top: '73%', textAlign: 'center', fontSize: '8px', fontColor: "#F33030" }], background: '#FFFBE6', imgs: [] },
    { x: 1, y: 2, fonts: [{ text: '', top: '73%', textAlign: 'center', fontSize: '8px', fontColor: "#F33030" }], background: '#FFFBE6', imgs: [] },
    { x: 0, y: 2, fonts: [{ text: '', top: '73%', textAlign: 'center', fontSize: '8px', fontColor: "#F33030" }], background: '#FFFBE6', imgs: [] },
    { x: 0, y: 1, fonts: [{ text: '', top: '73%', textAlign: 'center', fontSize: '8px', fontColor: "#F33030" }], background: '#FFFBE6', imgs: [] }
]);
const buttons = [
    {
        x: 1,
        y: 1,
        row: 1, col: 1,
        imgs: [{
            src: b,
            width: '100%',
            height: '100%',
        }],
    }
];
const taskLIstdata = ref([]);
const userDrawPrizeNumber_ = ref(0);
const index___ = ref([]);
const pitchDetail: any = ref({});
const addressShow__item: any = ref({});
const trackingNumberbtn = (item: any) => {
    if (!item.trackingNumber) {
        ElMessageBox.confirm(
            '将在1-3个工作日进行发货处理',
            '暂无快递单号信息，请等待工作人员处理',

            {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'ShowActivity_',
                center: true,
            }
        )
            .then(() => {

            }).catch(() => {

            })
    } else {
        addressShow__item.value = item;
        addressShow__.value = true;
    }
}
const commodityList = async () => {
    let res = await Axios("get", "/system/activity/prizePool/" + id.value, null, false, function (res: any) {
        if (res.data.code == 200) {
            if (res.data.data.length.length > 8) {
                return
            }
            for (let i = 0, item = res.data.data.length; i < item; i++) {
                prizes.value[i].fonts[0].text = res.data.data[i].name;
                prizes.value[i].imgs = [{
                    src: res.data.data[i].image,
                    width: '62%',
                    height: '55%',
                    rotate: true,
                    top: '10%',
                    // borderRadius: '10px'
                }];
            }
            prizes.value = prizes.value.slice(0, res.data.data.length); // 截取数组
            index___.value = res.data.data;
        } else {
            ElMessage.error(res.data.msg || "查询失败");
        }
    })
}
const goToTask = (item: any) => {
    if (item.taskType == 1) {
        if (localStorage.getItem("token") == null) {
            router.push({
                path: "/TgLogin",
            });
            return
        }
        router.push({
            path: "/AuthenTication",
            query: { num: 3 }
        });
    } else {
        router.push({
            path: "/ShowActivity",
            query: {
                t: encodeURIComponent(JSON.stringify(Object.assign(item, {
                    activityType: activityType.value,
                    stopTime: stopTime.value,
                    startTime: startTime.value,
                })))
            }
        });
    }
}
// 点击抽奖按钮会触发star回调
const startCallback = async () => {
    if (localStorage.getItem("token") == null) {
        router.push({
            path: "/TgLogin",
        });
        return
    }
    if (Number(userDrawPrizeNumber_.value) == 0) {
        return ElMessage.error("您还未获得过抽奖次数")
    }
    // 调用抽奖组件的play方法开始游戏
    myLucky?.value?.play()
    // 模拟调用接口异步抽奖
    let res = await Axios("post", "/system/activity-join/prize", {
        activityId: id.value
    }, false, function (res: any) {
        if (res.data.code == 200) {
            index___.value.filter((item: any, index: number) => {
                if (res.data && res.data.data.prizeId == item.id) {
                    pitchDetail.value = Object.assign(item, {
                        id: res.data.data.recordsLogId
                    });
                    myLucky?.value?.stop(index)
                    return
                }
            });
        }
    })
}
// 抽奖结束会触发end回调
const endCallback = (prize: any) => {
    setTimeout(() => {
        if (pitchDetail.value.prizeType == 3) {
            thanksShow.value = true;
        } else {
            ts.value = true;
        }
    }, 0);

    getInfo()
    commodityList()
}
const addressShowBtn = () => {
    conversionType.value = 0;
    conversionShow.value = true
}
const conversionBtn = (flag?: string, item: any) => {
    conversionType.value = {};
    conversionData.value = {
        prizePhone: "",
        name: "",
        address: "",
        addressDetail: ""
    };
    if (flag == "clear") {
        ts.value = false;
        Object.keys(pitchDetail.value).length ? (conversionType.value = pitchDetail.value) : (conversionType.value = item);
        conversionShow.value = true
        return
    }
    conversionType.value = item;
    conversionShow.value = true
}
const lotteryPage = ref({
    pageNum: 1,
    pageSize: 5,
    total: 0,
});
const lotteryList = ref([]);
const lotteryShowBtn = async () => {
    if (localStorage.getItem("token") == null) {
        router.push({
            path: "/TgLogin",
        });
        return
    }
    pitchDetail.value = {};
    lotteryLoading.value = true;
    let res = await axios({
        url: `https://api.biaoshisx.com/system/activity-join/prizeList?pageNum=${lotteryPage.value.pageNum}&pageSize=${lotteryPage.value.pageSize}`,
        method: "post",
        data: {
            activityId: id.value
        },
        headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*",
        }
    });
    if (res.data.code == 200) {
        lotteryList.value = res.data.rows;
        lotteryPage.value.total = res.data.total;
        lotteryShow.value = true;
    } else {
        ElMessage.error(res.data.msg || "查询失败");
    }
    lotteryLoading.value = false;
}
const paginationChange = (num: number) => {
    lotteryPage.value.pageNum = num;
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
    lotteryShowBtn()
}
const conversionClick = async (formEl) => {
    if (!formEl) return
    await formEl.validate(async (valid, fields) => {
        if (valid) {
            lotteryLoading.value = true;
            let res = await axios({
                url: `https://api.biaoshisx.com/system/activity-join/receivePrize?recordsLogId=${conversionType.value.id}&name=${conversionData.value.name}&address=${conversionData.value.address ? (conversionData.value.address as any).join('-') : ""}&prizePhone=${conversionData.value.prizePhone}&addressDetail=${conversionData.value.addressDetail}`,
                method: "post",
                headers: {
                    Accept: "*/*",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "Access-Control-Allow-Origin": "*",
                }
            });
            if (res.data.code == 200) {
                Object.keys(pitchDetail.value).length ? "" : lotteryShowBtn()
                conversionShow.value = false
            } else {
                ElMessage.error(res.data.msg)
            }
        }
    })
}
import img____ from "../../assets/fx.png"
const getInfo = function () {
    Axios("get", "/system/activity/web/" + id.value, null, false, function (res: any) {
        if (res.data.code == 200) {
            activityType.value = res.data.data.activityType
            title.value = res.data.data.title
            content.value = res.data.data.noticeContent || ''
            backgroundImage.value = res.data.data.backgroundImage
            stopTime.value = res.data.data.stopTime
            startTime.value = res.data.data.startTime
            taskLIstdata.value = res.data.data.taskList
            userDrawPrizeNumber_.value = res.data.data.userDrawPrizeNumber
            // console.log(taskLIstdata.value)
            getsignatureInfo({
                url: encodeURIComponent(location.href.split('#')[0]),
                title: res.data.data.title,
                desc: res.data.data.introduction,
                imgUrl: res.data.data.shareImage || img____
            })
        } else {
            ElMessage.error(res.data.message);
        }
    });
};
const copyBtn = async (val?: string) => {
    await toClipboard(val == 'a' ? addressShow__item.value.trackingNumber : `https://biaoshisx.com/drawList?id=${id.value}`);
    ElMessage.success("复制成功");
    isShowShare.value = false;
    addressShow__.value = false;
}
const getQrCode = function () {
    let opts = {
        errorCorrectionLevel: 'H',
        type: 'image/png',
        quality: 1,
        margin: 2,
        width: 200,
        height: 200,
        text: route.fullPath,
        color: {
            light: '#fff'
        }
    }
    QRCode.toCanvas(qrcodeCanvas.value, location.href, opts, function (error: any) { if (error) console.info(error) });
}
const getDay = function () {
    const endTime = new Date(stopTime.value)
    const now = new Date()
    return ((endTime.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)).toFixed(0);
}
const isOver = function () {
    const endTime = new Date(stopTime.value)
    const beginTime = new Date(startTime.value)
    const now = new Date()
    if (endTime.getTime() < now.getTime()) {
        return true;
    } else if (beginTime.getTime() > now.getTime()) {
        return true;
    }
    return false
}
const handleShare = function () {
    isShowShare.value = !isShowShare.value
    nextTick(() => {
        getQrCode()
        if (!!qrcodeCanvas.value) {
            let ctx = qrcodeCanvas.value.getContext('2d')
            let image = new Image()
            image.crossOrigin = 'Anonymous'
            image.src = 'qrcodelogo.png'
            image.onload = () => {
                ctx.drawImage(image, 75, 75, 50, 50)
            }
        }
    })
}
watch(() => content.value, () => {
    nextTick(() => {
        document.querySelectorAll('p').forEach(function (parent) {
            let img = parent.querySelector('img')
            if (img) {
                parent.classList.add('has-img');
                img.addEventListener("click", function (e) {
                    var href = this.getAttribute('data-href')
                    if (href)
                        if (href.indexOf('http') > -1 || href.indexOf('https') > -1) {
                            window.open(href, '_target')
                        }
                })
                if (!!img.getAttribute('data-alt') && img.getAttribute('data-alt') != 'null') {
                    var div = document.createElement("div");
                    div.style.position = "absolute";
                    div.style.left = img.offsetLeft + 'px';
                    div.classList.add("image-title")
                    div.style.width = img.clientWidth + 'px'
                    div.style.top = (img.offsetTop + img.clientHeight - 40) + 'px';
                    div.innerText = img.getAttribute('data-alt') as string;
                    parent.append(div);
                }

            }
        })
        previeHeight.value = previewRef.value.scrollHeight
    })
})
onBeforeMount(() => {
    id.value = route.query.id?.toString()
    getInfo()
    commodityList()
})
onMounted(async () => {
    await nextTick();

})

</script>
<style lang="less" scoped>
.ccc {
    width: 800px !important;
    margin: 0 auto !important;
    padding-top: 98px;
    margin-bottom: 32px !important;
}

.myLucky_ {
    // width: 501px !important;
    // height: 265px !important;
    // margin-left: -8px;
    transform-origin: center;
    transform: scale(1);
    // padding-left: 15px;
    box-sizing: border-box;
}

// /deep/.myLucky_ canvas {
// width: 563.75px !important;
//     height: 432px !important;
// }

/deep/.l {
    position: relative;
}

.x {
    position: absolute;
    width: 62px;
    height: 62px;
    background-image: url('../../assets/x.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    top: -27px;
    left: 50%;
    transform: translateX(-50%);
}

.x_ {
    position: absolute;
    width: 143px;
    height: 80px;
    background-image: url('../../assets/xx.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    top: -27px;
    left: 50%;
    transform: translateX(-50%);
}

.jackpot {
    width: 100%;
    height: 400px;
    padding-top: 10px;
    background-image: url("../../assets/cjbg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border-radius: 10px;

}

.lottery__ {
    flex: none;
    width: 48%;
    height: 389px;
    padding: 37px 21px 28px;
    box-sizing: border-box;
    background-image: url("../../assets/cjzz.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

/deep/.myLucky_ canvas {
    // width: 590px !important;
    margin-top: -8px !important;
}

.sp+.sp {
    margin-top: 20px;
}

.tip {
    position: fixed;
    left: 10px;
    top: 30%;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #ff8a43;
    background: #ffdfcc;
    font-weight: 700;
    padding: 10px;
    line-height: 24px;
    border-radius: 5px;
    z-index: 999999;
}

.share {
    position: fixed;
    left: 10px;
    top: calc(30% + 100px);
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #676869;
    background: #e3e6ec;
    font-weight: 700;
    padding: 10px 14px;
    line-height: 24px;
    border-radius: 5px;
    cursor: pointer;
    z-index: 999999;
    user-select: none;
}

.qrcode {
    position: fixed;
    left: 80px;
    top: calc(30% + 100px);
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #000;
    background: #fff;
    font-weight: 700;
    padding: 30px;
    line-height: 24px;
    border-radius: 10px;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
    z-index: 999999;

    .qrcode-box {
        border: 1px solid #e3e6ec;
        border-radius: 10px;
        padding: 2px;
    }
}

/deep/.image-title {
    display: none !important;
}

.container {
    width: 100%;
    // height: auto;
    // margin: 0 auto;
    display: flex;
    border-radius: 12px;
    justify-content: space-between;
    flex-wrap: wrap;
    background: var(--background);
    background-size: 100% 100%;
    padding: 40px;
    // margin-bottom: 40px;


    .title {
        text-align: left;
        font-size: 17px;
        font-weight: 700;
        position: relative;
        color: #000;
        z-index: 99;
    }

    .preview {
        position: relative;
        line-height: 1.5;
        height: auto;
        // padding-bottom: 20px;
        // min-height: calc(100vh - 300px);
        text-align: left;
        width: 100%;

        /deep/ table {
            border-collapse: collapse;

            th {
                background-color: #f5f2f0;
                font-weight: 700;
                text-align: center;
            }

            td,
            th {
                border: 1px solid #ccc;
                line-height: 1.5;
                min-width: 30px;
                padding: 3px 5px;
                text-align: left;
            }

            td {
                height: 24px;
            }
        }

        /deep/ a {
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
            -webkit-user-select: none;
            -moz-user-focus: none;
            -moz-user-select: none;
            color: #409eff;
        }

        /deep/ p,
        /deep/ div {
            position: relative;
            z-index: 2;
        }

        /deep/ hr {
            border-color: #ccc;
            display: block;
            height: 1px;
            margin: 20px auto;
        }

        /deep/ p {
            margin: 15px 0;
        }

        /deep/ p:has(img) {
            position: initial;
        }

        /deep/ p.has-img {
            position: initial;

            img {
                width: 100% !important;
            }

            .image-title {
                padding: 0.12rem 0.16rem;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
                border-radius: 0.12rem;
                transition: bottom 0.5s;
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                color: #fff;
            }
        }

        /deep/video {
            width: 100% !important;
            object-fit: scale-down !important;
        }

        /deep/audio {
            width: 100% !important;
        }

        /deep/ [data-w-e-type='video'],
        /deep/ [data-w-e-type='audio'] {
            text-align: center;
        }

        /deep/ [data-visibility='1'] {
            display: none;
        }

        /deep/ [data-position='0'] {
            z-index: 2;
        }

        /deep/ [data-position='1'] {
            z-index: 3;
        }

        /deep/ [data-position='2'] {
            z-index: 1;

            img {
                z-index: 0;
            }
        }

        /deep/ blockquote {
            background-color: #f5f2f0;
            border-left: 8px solid #B4D5FF;
            display: block;
            font-size: 100%;
            line-height: 1.5;
            margin: 10px 0;
            padding: 10px;
        }
    }
}
</style>

<style lang="less">
.ShowActivity_ .el-message-box__title {
    display: flex !important;
    flex-direction: column !important;
    font-size: 19px !important;
    padding-left: 25px !important;
}

.ShowActivity_ .el-message-box__status.el-message-box-icon--warning {
    font-size: 60px !important;
}

.ShowActivity_ {
    border-radius: 12px !important;
}

.ShowActivity_ .el-message-box__btns {
    button {
        width: 88px !important;
        line-height: 32px !important;
        text-align: center;
        line-height: 32px;
    }
}
</style>
